import { REQUIRED_MESSAGE, requiredString } from "components/form/utils";
import * as z from "zod";

// Dedicated job config schema
export const dedicatedJobConfigSchema = z.object({
  cost: z
    .number({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Cost must be a number",
    })
    .min(0, "Cost must be in positive or 0"),
  paid_leaves: z
    .number({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Paid Leave must be a number",
    })
    .min(0, { message: "Paid Leave must be zero or greater" }),
  currency: z
    .string({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Invalid currency",
    })
    .min(1, "Currency is required"),
});
